// Κείμενα της οθόνης κρατήσεων (namespace reservations) και ετικέτα ημέρας.

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { addDays } from './model';

export function useK() {
  const { t, i18n } = useTranslation(['reservations']);
  const k = useCallback((key: string, vars?: Record<string, unknown>) => String(t(`reservations:${key}`, vars as never)), [t]);
  const locale = i18n.language?.startsWith('en') ? 'en-GB' : 'el-GR';
  const dayLabel = useCallback((date: string, today: string) => {
    if (date === today) return k('day.today');
    if (date === addDays(today, 1)) return k('day.tomorrow');
    if (date === addDays(today, -1)) return k('day.yesterday');
    return new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(new Date(`${date}T12:00:00Z`));
  }, [k, locale]);
  /** Τα μηνύματα του server (αγγλικά) σε κείμενο για το προσωπικό. */
  const errText = useCallback((e: unknown) => {
    const status = (e as { status?: number })?.status;
    const msg = e instanceof Error ? e.message : String(e);
    if (status === 403) return k('err.forbidden');
    if (/already reserved/i.test(msg)) return k('err.reserved');
    if (/open bill/i.test(msg)) return k('err.openBill');
    if (/capacity/i.test(msg)) return k('err.capacity');
    if (/no longer available|not available/i.test(msg)) return k('err.taken');
    if (/^Cannot /i.test(msg)) return k('err.state');
    if (/Failed to fetch|NetworkError/i.test(msg)) return k('err.network');
    return msg;
  }, [k]);
  return { k, locale, dayLabel, errText };
}
